import { vuexfireMutations } from 'vuexfire'
import Vue from 'vue'
import Vuex from 'vuex'

// Modules:
import answers from '@/store/modules/answers'
import currentHour from '@/store/modules/currentHour'
import fishing from '@/store/modules/fishing'
import hours from '@/store/modules/hours'
import me from '@/store/modules/me'
import notification from '@/store/modules/notification'
import questions from '@/store/modules/questions'
import users from '@/store/modules/users'
import visuals from '@/store/modules/visuals'
import audioRecorder from '@/store/modules/audioRecorder'
import siteSettings from '@/store/modules/siteSettings'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const bindQueue = []

const wantBind = function (callback) {
  if (me.state.loggedIn) {
    callback()
    return
  }
  bindQueue.push(callback)
}

const unleashBinds = function () {
  bindQueue.forEach((callback) => {
    callback()
  })
}

export { wantBind, unleashBinds }

export default new Vuex.Store({
  mutations: {
    ...vuexfireMutations,
  },
  modules: {
    answers,
    currentHour,
    hours,
    fishing,
    me,
    notification,
    questions,
    users,
    visuals,
    audioRecorder,
    siteSettings,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
})
